// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"24418736","151":"2a733c1f","201":"ee427b70","234":"9d80491b","464":"58ba8d98","491":"2fb44296","589":"007966cc","749":"403c259b","921":"d87b657c"}[chunkId] + ".chunk.js";
};